import React from 'react';
import Select, { components } from 'react-select';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: 'transparent',
    color: '#262626',
    width: '100%',
    alignItems: 'center',
    fontSize: '12px',
    minHeight: '32px',
    height: 'auto',
    borderRadius: '4px',
    boxShadow: 'transparent',
    borderColor: state.isFocused ? 'rgb(31, 70, 128)' : '#dbdbdb',
    outline: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    overflowX: 'auto',
    paddingRight: '10px',
    textAlign: 'left',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#ffe9d2',
    padding: '0px 4px',
    borderRadius: '4px',
    display: 'inline-flex',
    maxWidth: 'none',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#f88f14',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#f88f14',
    cursor: 'pointer',
    ':hover': {
      color: '#f88f14',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#262626',
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#262626',
    backgroundColor: state.isFocused ? 'rgba(31, 70, 128, 0.1)' : 'white',
    cursor: 'pointer',
    fontSize: '12px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  indicatorSeparator: () => ({}),
};

function Control(props) {
  return (
    <components.Control
      {...props}
      innerProps={{
        ...props.innerProps,
        'data-testid': props.selectProps['data-testid'],
      }}
    />
  );
}

function CustomMultiSelect({
  options,
  onChange,
  disabled,
  isClearable = true,
  ...props
}) {
  return (
    <Select
      isMulti
      isClearable={isClearable}
      options={options}
      onChange={onChange}
      styles={customStyles}
      isDisabled={disabled}
      components={{ Control }}
      menuPlacement="auto"
      {...props}
    />
  );
}

export default CustomMultiSelect;
